import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { AppDispatch } from 'app/store';

export type SaveTracker = {
  request: () => number;
  complete: (seq: number) => void;
};

type SaveTrackerActions = {
  requested: ActionCreatorWithPayload<number>;
  completed: ActionCreatorWithPayload<number>;
};

export function createSaveTracker(
  dispatch: AppDispatch,
  actions: SaveTrackerActions
): SaveTracker {
  let lastSeq = 0;
  return {
    request: () => {
      lastSeq += 1;
      dispatch(actions.requested(lastSeq));
      return lastSeq;
    },
    complete: (seq) => {
      dispatch(actions.completed(seq));
    }
  };
}
